<template>
  <div class="move-btn-box">
    <router-link tag="button"  :to="lastPage.link" v-show="lastBtnHidden" class="move-to-left"><span><i class="fas fa-arrow-left"></i></span>{{ lastPage.name }}</router-link>
    <router-link tag="button" :to="nextPage.link" v-show="nextBtnHidden" class="move-to-right">{{ nextPage.name }}<span><i class="fas fa-arrow-right"></i></span></router-link>
  </div>
</template>

<script>
export default {
  props: {
    lastPage: {
      type: [String, Object, Function],
      default: "empty",
      required: false
    },
    nextPage: {
      type: [String, Object, Function],
      default: "empty",
      required: false
    },
  },
  computed: {
    lastBtnHidden: function() {
      return this.lastPage !== "empty";
    },
    nextBtnHidden: function() {
      return this.nextPage !== "empty";
    },
  },
}
</script>


<style lang="scss" scoped>
    $cDark: #073278;
    $f14px: 14px;
    $f16px: 16px;
    $f18px: 18px;
    $f20px: 20px;
    $f24px: 24px;
    $f28px: 28px;

    .move-btn-box {
      display: flex;
      padding: 10px;
    
      & .move-to-left {
        display: inline-block;
        background-color: transparent;
        border: none;
        cursor: pointer;
        font-size: $f20px;
        padding: 0.1em 0.4em 0.1em 0.2em;
        color: $cDark;
        border-bottom: 2px solid $cDark;
        margin-right: auto;
        outline: none;

        & span {
          display: inline-block;
          font-size: $f18px;
          margin-right: 10px;
        }
      }

      & .move-to-right {
        display: inline-block;
        background-color: transparent;
        border: none;
        cursor: pointer;
        font-size: $f20px;
        padding: 0.1em 0.2em 0.1em 0.4em;
        color: $cDark;
        border-bottom: 2px solid $cDark;
        margin-left: auto;
        outline: none;


        & span {
          display: inline-block;
          font-size: $f18px;
          margin-left: 10px;
        }
      }
    }
</style>